export const CATALOG_URL = process.env.PUBLIC_CATALOG_URL
export const AUTH_URL = process.env.PUBLIC_AUTH_URL
export const QUERY_BUILDER_URL = process.env.PUBLIC_QUERY_BUILDER_URL
export const S3_IMAGE_BUCKET = process.env.PUBLIC_S3_IMAGE_BUCKET
export const TF_LIVE = process.env.PUBLIC_TF_LIVE
export const AI_URL = process.env.PUBLIC_AI_URL
export const RECAPTCHA_ID = process.env.PUBLIC_RECAPTCHA_ID

export const AVATAR_COLORS = [
  '#7a85ff',
  '#FF6265',
  '#FFB662',
  '#FF62D8',
  '#A6FF62',
  '#C562FF',
  '#62FFE5',
  '#FAFF62',
  '#62C3FF',
  '#BFF9FF',
  '#8a75ff',
  '#FF1B63',
  '#2979ff',
  '#2a9aad',
  '#c892ef',
  '#FF8D06',
  '#3365cd',
  '#34c2af',
  '#aa50fa'
]
